import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
    font-size: ${theme.type.root};
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    border-color: ${theme.colors.border};
  }

  body {
    margin: 0;
    background: ${theme.colors.background};
    color: ${theme.colors.foreground};
    font-family: ${theme.fonts.sans};
    font-feature-settings: 'ss01', 'cv11';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, .font-display {
    font-family: ${theme.fonts.display};
    font-weight: 400;
    letter-spacing: -0.01em;
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  .font-mono-luxe {
    font-family: ${theme.fonts.sans};
    letter-spacing: 0.2em;
    text-transform: uppercase;
    font-weight: 500;
  }

  .text-balance {
    text-wrap: balance;
  }

  .marquee-track {
    animation: marquee 40s linear infinite;
    display: flex;
    flex-shrink: 0;
    gap: 4rem;
    padding-right: 4rem;
  }

  .animate-fade-in {
    animation: fade-in 0.6s ${theme.easeLuxe} both;
  }

  @keyframes marquee {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Product card imagery (parity with chic-style-hub product-card hover image) */
  .product-card-img {
    transition:
      transform 1.2s ${theme.easeLuxe},
      opacity 0.5s ease;
  }

  .product-card:hover .product-card-img {
    transform: scale(1.06);
  }

  /* Luxe underline (hover expands) */
  .underline-luxe {
    background-image: linear-gradient(currentColor, currentColor);
    background-size: 0% 1px;
    background-repeat: no-repeat;
    background-position: 0 100%;
    transition: background-size 0.5s ${theme.easeLuxe};
  }

  .underline-luxe:hover {
    background-size: 100% 1px;
  }

  /* Backend HTML blocks (parity with shop/client About DynamicContent / legal prose) */
  .store-content-html {
    color: ${theme.colors.mutedForeground};
    line-height: 1.75;
    font-size: 1rem;
  }

  .store-content-html p {
    margin: 0 0 1rem;
  }

  .store-content-html h2 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-family: ${theme.fonts.display};
    font-size: 1.75rem;
    font-weight: 300;
    color: ${theme.colors.foreground};
  }

  .store-content-html h3 {
    margin-top: 1.5rem;
    margin-bottom: 0.75rem;
    font-family: ${theme.fonts.display};
    font-size: 1.25rem;
    font-weight: 500;
    color: ${theme.colors.foreground};
  }

  .store-content-html ul,
  .store-content-html ol {
    margin: 0 0 1rem;
    padding-left: 2rem;
  }

  .store-content-html li {
    margin-bottom: 0.5rem;
  }
`;
